<template>
  <transition name="fade">
    <v-row v-if="showGuide">
      <v-col cols="12">
        <v-card outlined color="grey lighten-2">
          <v-card-title>Complete {{ steps.length }} simple steps to host your first tutorial</v-card-title>
          <v-card-text>
            <v-list two-line dense>
              <v-list-item v-for="(step, index) in steps" :key="step.code" two-line @click="redirectTo(step.routerData)">
                <v-list-item-avatar>
                  <v-icon large>{{ step.icon }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ index + 1 }}. {{ step.title }}</v-list-item-title>
                  <v-list-item-subtitle class="mt-1">{{ step.subTitle }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon large color="green" v-if="hasCompleted(step.code)">check_box</v-icon>
                  <v-icon large v-else>check_box_outline_blank</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Guide',
  data() {
    return {
      steps: [
        { 
          code: 'CREATE_TUTORIAL',
          icon: 'topic',
          title: 'Create a subject and tutorial', 
          subTitle: 'Go to the Content page to create your first subject and tutorial', 
          routerData: { name: 'Content' }
        },
        { 
          code: 'SCHEDULE_TEACHING_SESSION',
          icon: 'schedule',
          title: 'Schedule your tutorial', 
          subTitle: 'Set a time and date where you will be available to screenshare with students', 
          routerData: { name: 'Schedule' }
        },
        { 
          code: 'COPY_INVITE_LINK',
          icon: 'share',
          title: 'Share an invitation with students', 
          subTitle: 'Click the share icon and copy the invitation link to share with your students', 
          routerData: { name: 'Schedule' }
        },
        { 
          code: 'OFFERED_SCREENSHARE',
          icon: 'dashboard',
          title: 'Start a 1-to-1 screenshare to assist a student', 
          subTitle: 'During a scheduled tutorial students can request a screenshare', 
          routerData: { name: 'LecturerDashboard' }
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      lecturer: 'lecturer'
    }),
    showGuide() {
      let showGuide = false
      if (this.lecturer.data) {
        const stepStatuses = this.steps.map(step => this.hasCompleted(step.code))
        if (stepStatuses.includes(false)) {
          // They have not completed all steps
          showGuide = true
        } 
      }
      return showGuide
    }
  },
  methods: {
    hasCompleted(stepCode) {
      // Guard in case lecturer hasn't loaded yet
      return this.lecturer.data && this.lecturer.data.completedSteps.includes(stepCode)
    },
    redirectTo(routerData) {
      this.$router.push(routerData)
    }
  }
}
</script>

<style scoped>

.fade-leave-active {
  transition: opacity 5s;
}
.fade-leave-to {
  opacity: 0;
}
</style>
